import AnimatedLayout from 'components/layouts/animated-layout';
import PageWithDialogLayout from 'components/layouts/page-with-dialog/page-with-dialog-layout';
import { TelegramIDNotificationForm, AdressesForm } from 'features/profile';
import DisableTelegramBotForm from 'features/profile/components/forms/disable-telegram-bot.form';
import Tabs from './tabs/tabs';

const ProfileSettingsPage = () => {
    return (
        <PageWithDialogLayout
            dialogs={{
                'new-address': {
                    label: 'افزودن آدرس',
                    icon: <i className="fa-light fa-plus"></i>,
                    type: 'success',
                    maxWidth: 'sm',
                    width: '720px',
                    children: <AdressesForm />,
                },
                'set-telegram-id': {
                    label: 'تنظیم شناسه تلگرام',
                    icon: (
                        <i className="fa-light fa-paper-plane"></i>
                    ),
                    type: 'warning',
                    children: <TelegramIDNotificationForm />,
                },
                'disable-telegram-bot': {
                    label: 'غیرفعالسازی ربات',
                    icon: <i className="fa-light fa-power-off"></i>,
                    type: 'error',
                    strictClosing: true,
                    width: '390px',
                    children: <DisableTelegramBotForm />,
                },
            }}>
            <AnimatedLayout>
                <Tabs />
            </AnimatedLayout>
        </PageWithDialogLayout>
    );
};

export default ProfileSettingsPage;
